import React from 'react'
import TextMore from "../../Sources/component/TextMore";

export const mobileGameFieldsColumn = <T extends Function>(formatMessage: T) => [
  {
    key: 'id',
    fixed: 'left',
    align: 'left',
    width: 65,
    header: '#',
  },
  {
    key: 'metric_definition',
    align: 'left',
    fixed: 'left',
    width: 200,
    header: formatMessage({ id: 'dbi-sm-table-fieldsdefinition' }),
    render: (cvm) => cvm?.metric_definition || '-',
  },
  {
    key: 'metric',
    align: 'left',
    width: 220,
    header: formatMessage({ id: 'dbi-sm-table-fieldsName' }),
    render: (cvm) => cvm?.metric || '-',
  },
  {
    key: 'description',
    align: 'left',
    width: 300,
    header: formatMessage({ id: 'dbi-sm-table-description' }),
    render: (cvm) => cvm?.description || '-',
  },
  {
    key: 'aggregation_logic',
    align: 'left',
    header: formatMessage({ id: 'dbi-sm-table-aggregation' }),
    width: 400,
    render: (cvm) => cvm?.aggregation_logic ? (
      <TextMore
        data={cvm?.aggregation_logic.replace(/(\r\n|\n|\r)/gm, '<br/>')}
        title={formatMessage({ id: 'dbi-sm-table-aggregation' })}
      />
    ) : (
      '-'
    ),
  },
]

export const opinionsMetricsColumn = (...[formatMessage]: Parameters<typeof mobileGameFieldsColumn>) => [
  {
    key: 'id',
    fixed: 'left',
    width: 65,
    header: '#',
  },
  {
    key: 'metric',
    fixed: 'left',
    width: 160,
    header: formatMessage({ id: 'dbi-sm-filter-metrics' }),
    render: (cvm) => (cvm?.metric ? cvm?.metric : '-'),
  },
  {
    key: 'metric_cn',
    width: 150,
    header: formatMessage({ id: 'dbi-sm-table-metrics-cn' }),
    render: (cvm) => (cvm?.metric_cn ? cvm?.metric_cn : '-'),
  },
  {
    key: 'metric_definition',
    width: 480,
    header: formatMessage({ id: 'dbi-sm-table-description' }),
    render: (cvm) =>
      cvm?.metric_definition ? (
        <TextMore
          data={cvm?.metric_definition.replace(/(\r\n|\n|\r)/gm, '<br/>')}
          title={formatMessage({ id: 'dbi-sm-table-description' })}
        />
      ) : (
        '-'
      ),
  },
  {
    key: 'granularity',
    header: formatMessage({ id: 'dbi-sm-table-datagranularity' }),
    width: 150,
    render: (cvm) => (cvm?.granularity ? cvm?.granularity : '-'),
  },
]

export const pCConsoleFieldsColumn = (...[formatMessage]: Parameters<typeof mobileGameFieldsColumn>) => [
  {
    key: 'id',
    fixed: 'left',
    width: 65,
    header: '#',
  },
  {
    key: 'metric_definition',
    fixed: 'left',
    width: 250,
    header: formatMessage({ id: 'dbi-sm-filter-fieldsdefinition' }),
    render: (cvm) => cvm?.metric_definition ? cvm?.metric_definition : '-',
  },
  {
    key: 'metric',
    width: 220,
    header: formatMessage({ id: 'dbi-sm-filter-fieldsName' }),
    render: (cvm) => cvm?.metric ? cvm?.metric : '-',
  },
  {
    key: 'description',
    width: 300,
    header: formatMessage({ id: 'dbi-sm-filter-description' }),
    render: (cvm) => cvm?.description ? cvm?.description : '-',
  },
  {
    key: 'aggregation_logic',
    header: formatMessage({ id: 'dbi-sm-filter-aggregation' }),
    width: 400,
    render: (cvm) => cvm?.aggregation_logic ? (
      <TextMore
        data={cvm?.aggregation_logic.replace(/(\r\n|\n|\r)/gm, '<br/>')}
        title={formatMessage({ id: 'dbi-sm-filter-aggregation' })}
      />
    ) : (
      '-'
    ),
  },
]

export const companyFieldsColumn = (...[formatMessage]: Parameters<typeof mobileGameFieldsColumn>) => [
  {
    key: 'id',
    fixed: 'left',
    align: 'left',
    width: 65,
    header: "#",
  },
  {
    key: 'metric_definition',
    fixed: 'left',
    align: 'left',
    width: 300,
    header: formatMessage({ id: 'dbi-sm-table-definition' }),
    render: (cvm) => cvm?.metric_definition ? cvm?.metric_definition : '-'
  },
  {
    key: 'metric',
    align: 'left',
    width: 300,
    header: formatMessage({ id: 'dbi-sm-table-fieldsName' }),
    render: (cvm) => cvm?.metric ? cvm?.metric : '-'
  },
  {
    key: 'description',
    align: 'left',
    width: 300,
    header: formatMessage({ id: 'dbi-sm-table-description' }),
    render: (cvm) => cvm?.description ? cvm?.description : '-'
  },
  {
    key: 'aggregation_logic',
    align: 'left',
    header: formatMessage({ id: 'dbi-sm-table-aggregation' }),
    width: 300,
    render: (cvm) => cvm?.aggregation_logic ? cvm?.aggregation_logic : '-'
  }
]
export const deviceMetricsColumn = (...[formatMessage]: Parameters<typeof mobileGameFieldsColumn>) => [
  {
    key: 'id',
    fixed: 'left',
    align: 'left',
    width: 65,
    header: "#",
  },
  {
    key: 'metric',
    fixed: 'left',
    align: 'left',
    width: 200,
    header: formatMessage({ id: 'dbi-sm-device-metrics-table-metric' }),
    render: (cvm) => cvm?.metric ? cvm?.metric : '-'
  },
  {
    key: 'metric_definition',
    align: 'left',
    width: 400,
    header: formatMessage({ id: 'dbi-sm-device-metrics-table-definition' }),
    render: (cvm) => cvm?.metric_definition ? (
      <TextMore
        data={cvm?.metric_definition.replace(/(\r\n|\n|\r)/gm, '<br/>')}
        title={formatMessage({ id: 'dbi-sm-device-metrics-table-definition' })}
      />
    ) : (
      '-'
    )
  },
  {
    key: 'description',
    align: 'left',
    width: 400,
    header: formatMessage({ id: 'dbi-sm-device-metrics-table-description' }),
    render: (cvm) => cvm?.description ? (
      <TextMore
        data={cvm?.description.replace(/(\r\n|\n|\r)/gm, '<br/>')}
        title={formatMessage({ id: 'dbi-sm-device-metrics-table-description' })}
      />
    ) : (
      '-'
    )
  }
]
